var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loading"},[_c('div',{staticClass:"loading-mask"}),_c('div',{staticClass:"loading-toast"},[_c('i',{staticClass:"loading-icon"}),_c('p',{staticClass:"loading-content"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }